<template>
  <layout>
    <rdkm-title>
      {{ $t('Справочник аллелей') }}
      <span class="d-flex float-right">  
      <user-accessible routerName="GroupGCodesEdit">
        <import-modal></import-modal>          
      </user-accessible>
      <user-accessible routerName="GroupGCodesEdit">
      <router-link tag="span" to="/groupGCodes/add">
        <b-button size="sm" variant="primary">
          <font-awesome-icon icon="plus" /> {{ $t('Добавить') }}
        </b-button>        
      </router-link>
      </user-accessible>
      </span>
    </rdkm-title>
    <div class="tile">
      <filter-form :hlaType="query.hlaType"
                   :sourceG="query.sourceG"
                   :dest="query.dest"
                   v-on:search="$refs.grid.filter($event, true)"></filter-form> 
      <rdkm-grid ref="grid" :state="query">
        <grid-column width="150" name="EDIT" cell="edit-cell"></grid-column>
        <grid-column width="150" name="hlaTypeName" :title="$t('Тип аллели')"></grid-column>
        <grid-column width="170" name="gGroupValue" :title="$t('Значение в группе G')"></grid-column>
        <grid-column name="value" :title="$t('Аллели в группе')"></grid-column>
      </rdkm-grid>
    </div>
  </layout>
</template>

<script>
import FilterForm from './Filter.vue';
import Grid from "../../components/grid/Grid.vue";
import GridColumn from "../../components/grid/GridColumn.vue";
import ImportModal from '@/pages/groupGCodes/ImportModal';

export default {
  name: "GroupGCodes",
  props: ["query"],
  components: {
    "rdkm-grid": Grid,
    "grid-column": GridColumn,
    "filter-form": FilterForm,
    'import-modal': ImportModal,
  }
};
</script>
